<div class="row justify-content-md-center">
	<div class="col-md-8 bg-white">
		<div class="border-bottom p-3">
			<h2>{{ isEditMode ? ('noc_config.edit_config' | translate) : ('noc_config.add_config' | translate) }}</h2>
		</div>
		<div class="px-5 py-4">
			<form #nocConfigForm="ngForm" (ngSubmit)="onSubmit()" [validate-form]="'nocConfiguration'" (keydown.enter)="$event.preventDefault()">
				<!-- Meter Number -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'device.meter_number' | translate}} *</strong>
					</div>
					<div class="col-md-8">
						<input
							type="number"
							class="form-control"
							name="meter_number"
							placeholder="{{'device.meter_number' | translate}}"
							[(ngModel)]="config.meter_number"
							[min]="0"
							[max]="32767"
							required
						/>
					</div>
				</div>

				<!-- Power View SN -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'iotemeter.devices.panel_id' | translate}} *</strong>
					</div>
					<div class="col-md-8">
						<input
							type="text"
							class="form-control"
							name="power_view_sn"
							placeholder="{{'iotemeter.devices.panel_id' | translate}}"
							[(ngModel)]="config.power_view_sn"
							[maxlength]="31"
							required
						/>
					</div>
				</div>

				<!-- Feeder Meter -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'device.feeder_meter' | translate}} *</strong>
					</div>
					<div class="col-md-8">
						<ng-select
							[items]="feederMeterOptions"
							bindLabel="label"
							bindValue="value"
							name="is_feeder_meter"
							placeholder="{{'device.feeder_meter' | translate}}"
							[(ngModel)]="config.is_feeder_meter"
							[clearable]="false"
							required
						>
						</ng-select>
					</div>
				</div>

				<!-- Accumulating/Subtracting -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'device.accumulating_subtracting' | translate}} *</strong>
					</div>
					<div class="col-md-8">
						<ng-select
							[items]="accumulatingOptions"
							bindLabel="label"
							bindValue="value"
							name="is_meter_subtracting"
							placeholder="{{'device.accumulating_subtracting' | translate}}"
							[(ngModel)]="config.is_meter_subtracting"
							[clearable]="false"
							required
						>
						</ng-select>
					</div>
				</div>

				<!-- CT Ratio -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'device.ct_ratio' | translate}} *</strong>
					</div>
					<div class="col-md-8">
						<ng-select
							[items]="ctRatioOptions"
							bindLabel="label"
							bindValue="value"
							name="ct_ratio"
							placeholder="{{'device.ct_ratio' | translate}}"
							[(ngModel)]="config.ct_ratio"
							[clearable]="false"
							required
						>
						</ng-select>
					</div>
				</div>

				<!-- Wiring Mode -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'device.service_type' | translate}} *</strong>
					</div>
					<div class="col-md-8">
						<ng-select
							[items]="wiringModeOptions"
							bindLabel="label"
							bindValue="value"
							name="wiring_mode"
							placeholder="{{'device.service_type' | translate}}"
							[(ngModel)]="config.wiring_mode"
							[clearable]="false"
							required
						>
						</ng-select>
					</div>
				</div>

				<!-- Nominal Voltage -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'device.nominal_voltage' | translate}} ({{ getNominalVoltageLabel() }}) *</strong>
					</div>
					<div class="col-md-8">
						<ng-select
							[items]="nominalVoltageOptions"
							bindLabel="label"
							bindValue="value"
							name="nominal_voltage"
							placeholder="{{'device.nominal_voltage' | translate}}"
							[(ngModel)]="config.nominal_voltage"
							[clearable]="false"
							required
						>
						</ng-select>
						<small class="form-text text-muted">
							{{'noc_config.voltage_type_hint' | translate}}: {{ getNominalVoltageLabel() }}
						</small>
					</div>
				</div>

				<!-- Empty NB-IoT Bands -->
				<div class="row mt-2 align-items-center">
					<div class="col-md-4">
						<strong>{{'noc_config.empty_nbiot_bands' | translate}}</strong>
					</div>
					<div class="col-md-8">
						<div class="form-check">
							<input
								type="checkbox"
								class="form-check-input"
								name="empty_nbiot_bands"
								id="empty_nbiot_bands"
								[(ngModel)]="config.empty_nbiot_bands"
							/>
						</div>
					</div>
				</div>

				<!-- Action Buttons -->
				<div class="row mt-4">
					<div class="col-md-12 text-right">
						<button type="button" class="btn btn-secondary mr-2" (click)="goBack()">
							<i class="fa fa-times mr-1"></i>
							{{'g.cancel' | translate}}
						</button>
						<button type="submit" class="btn btn-primary">
							<i class="fa fa-save mr-1"></i>
							{{'g.save' | translate}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
